export default __webpack_public_path__ + "static/media/arrow-bold-redo.db0b6b09.svg";